import React, { useState, useEffect, useRef } from "react";
import es_ES from "rsuite/locales/es_ES";
import {
  Calendar,
  Users,
  FileText,
  Plus,
  ChevronRight,
  Clock,
  CheckCircle2,
  UserCheck,
  Activity,
  AlertCircle,
  RefreshCw,
} from "lucide-react";
import {
  Modal,
  Input,
  Button,
  SelectPicker,
  toaster,
  CustomProvider,
  DatePicker,
  NumberInput,
  Panel,
  Message,
  Drawer,
} from "rsuite";
import { notification } from "antd";
import {
  getCitas,
  getHorarios,
  getTelefonoXID,
  saveUpdateCita,
  getPacienteXNombre,
  getListaPacientes,
  saveCancelCita,
  saveConfirmacion,
  getDatosConsulta,
} from "./Services/ConsultasServices";
import {
  getResumenCitas,
  getPacientesTotal,
  getPacientesRecientes,
} from "./Services/KpisServices";
import { LayoutMain } from "./LayoutMain";
import moment from "moment/moment";
import { Image } from "react-bootstrap";
import { FaCashRegister, FaTrash } from "react-icons/fa";
import { CheckIcon, ClockIcon } from "lucide-react";
import { GlassButton } from "../components/GalssButton";
import { ModalCobro } from "./Consulta/ModalCobro";
import { Agenda } from "./Citas/Agenda";

export const Dashboard = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const perfil = JSON.parse(localStorage.getItem("auth")).perfil;
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;
  const [fechaHoy] = useState(
    JSON.parse(localStorage.getItem("auth")).confApp.fechas,
  );

  const [nombreMedico] = useState(
    JSON.parse(localStorage.getItem("auth")).medico != null ? JSON.parse(localStorage.getItem("auth")).medico.medico 
    : JSON.parse(localStorage.getItem("auth")).nombre,
  );

  const [openAgenda, setOpenAgenda] = useState(false);

  const [api, contextHolder] = notification.useNotification();
  const modalCobro = useRef();

  const [messageConfirm, setMessageConfirm] = useState(
    JSON.parse(localStorage.getItem("auth")).confApp.msjConfirm,
  );

  const [activeTab, setActiveTab] = useState("dashboard");
  const [openHor, setOpenHor] = useState(false);

  const [disableBtn, setDisableBtn] = useState(true);

  // States
  const [citas, setCitas] = useState([]);
  const [pacientes, setPacientes] = useState([]);
  const [expedientes, setExpedientes] = useState([]);
  const [dataPaciente, setDataPaciente] = useState([]);
  const [dataEdit, setDataEdit] = useState("");
  const [fechaHorario, setFechaHorario] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  // Modals
  const [isPacienteModalOpen, setIsPacienteModalOpen] = useState(false);
  const [selectedPaciente, setSelectedPaciente] = useState(null);
  const [idConsulta, setIdConsulta] = useState(0);
  const [servicio, setServicio] = useState("");
  const [precio, setPrecio] = useState(0);

  const [listaOpc, setListaOpc] = useState([
    { label: "Confirmadas", value: "Confirmada" },
    { label: "Todas", value: "Todas" },
    { label: "Horarios Disponibles", value: "Disponible" },
    { label: "Agendadas", value: "Agendada" },
    { label: "Realizadas", value: "Realizada" },
    { label: "Canceladas", value: "Cancelada" },
  ]);

  const [horaConsulta, setHoraConsulta] = useState("");
  const [defaultVal] = useState("Confirmada");
  const [horario, setHorario] = useState("");
  const [tipoHorario, setTipoHorario] = useState("");
  const [espacio, setEspacio] = useState(0);
  const [idPaciente, setIdPaciente] = useState(0);
  const [opcionSelecc, setOpcSelecc] = useState("Confirmada");
  const [disableHors, setDisableHors] = useState(true);
  const [nuevaCita, setNuevaCita] = useState(false);
  const [nuevaFecha, setNuevaFecha] = useState("");
  const [horaIni, setHoraIni] = useState("");
  const [showListaPac, setSowListaPac] = useState(true);
  const [horNvaCita, setHorNvaCita] = useState("");
  const [dataHorarios, setDataHorarios] = useState([]);
  const [disabledBtmMsj, setDisabledBtnMsj] = useState(true);
  const [fecha, setFecha] = useState("");
  const [fechaCita, setFechaCita] = useState("");
  const [message, setMessage] = useState("");
  const [dataCancel, setDataCancel] = useState("");
  const [btnCancel, setBtnCancel] = useState(false);
  const [motivoCancel, setMotivoCancel] = useState("");

  const [openConfirm, setOpenConfirm] = useState(false);
  const [dataConfirm, setDataConfirm] = useState("");
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const handleCloseConfirm = () => setOpenConfirm(false);

  const [listaPacientes, setListaPacientes] = useState([
    { label: "+ NUEVO PACIENTE", value: "-1" },
  ]);

  const [paciente, setPaciente] = useState("");
  const [telefono, setTelefono] = useState("");
  const [nuevoPac, setNuevoPac] = useState(false);

  const [citasHoy, setCitasHoy] = useState(0);
  const [citasProg, setCitasProg] = useState(0);
  const [totPacientes, setTotPacientes] = useState(0);
  const [totExpedientes, setTotExpedientes] = useState(0);
  const [atendidos, setAtendidos] = useState(0);

  const handleCloseHorario = () => setOpenHor(false);

  const initialized = useRef(false);

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  };

  const maskTime = (value) => {
    setHoraIni(
      value
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "$1:$2")
        .replace(/(\d{2})(\d)/, "$1:$2"),
    );
  };

  const sendMessage = () => {
    var anchor = document.createElement("a");
    anchor.href = `https://api.whatsapp.com/send?phone=${telefono}&text=${messageConfirm}`;
    anchor.target = "_blank";
    anchor.click();
    setOpenHor(false);
  };

  const handleChangeFec = (e) => {
    if (e != null) {
      var fecha = new Date(e).toISOString();
      setDisableHors(false);
      setFecha(e);
      fetchHorarios(fecha);
    } else {
      setDataHorarios([]);
    }
  };

  const handleChangeTelefono = async (value) => {
    setTelefono(value);
  };

  const handleNuevoNombre = async (e) => {
    if (!e) {
      setDisableBtn(true);
      setPaciente("");
    } else {
      setDisableBtn(false);
      setPaciente(e);
    }
  };

  const saveConfirm = async () => {
    const data = {
      id: idNegocio,
      fechaCita: fechaCita,
      hora: horario,
      espacio: espacio,
    };

    await saveConfirmacion(data)
      .then((res) => {
        if (res.data > 0) {
          toast("Se ha confirmado la cita", "success");
          fetchCitas(opcionSelecc).then((res) => {
            loadKPIS();
          });
          setOpenConfirm(false);
        }
      })
      .catch((err) => {
        toast(err.message, "error");
      });
  };

  const hanldeNombrePaciente = async (e) => {
    if (e === null) {
      setIdPaciente("0");
      setSowListaPac(true);
      setNuevaCita(true);
      setPaciente("");
      setNuevoPac(true);
      setTelefono("");
      return;
    }

    if (e === "-1") {
      setIdPaciente("0");
      setSowListaPac(false);
      setNuevaCita(true);
      setPaciente("");
      setNuevoPac(true);
      setTelefono("");
      return;
    }

    const _idPac = e;
    const ID = _idPac.split("-")[0];

    setIdPaciente(e);
    const selectedItem = listaPacientes.find((item) => item.value === e);
    setPaciente(selectedItem.label);

    const res = await getTelefonoXID(idNegocio, ID, selectedItem.label);
    if (!res) {
      setTelefono("");
    }
    if (res.telefono === undefined) {
      return;
    }

    setTelefono(res.telefono);
  };

  const loadKPIS = async () => {
    await getResumenCitas(idNegocio)
      .then(async (res) => {
        if (res.length > 0) {
          const _citas = res.filter((c) => c.estatus === "Confirmada").length;
          if (_citas > 0)
            setCitasHoy(res.filter((c) => c.estatus === "Confirmada")[0].citas);

          const _prog = res.filter((c) => c.estatus === "Agendada").length;
          if (_prog > 0)
            setCitasProg(res.filter((c) => c.estatus === "Agendada")[0].citas);

          const _atendidas = res.filter(
            (c) => c.estatus === "Realizada",
          ).length;
          var atend = 0;
          if (_atendidas > 0)
            atend = parseFloat(
              res.filter((c) => c.estatus === "Realizada")[0].citas,
            );

          const _completadas = res.filter(
            (c) => c.estatus === "Completada",
          ).length;
          var complet = 0;
          if (_completadas > 0)
            complet = parseFloat(
              res.filter((c) => c.estatus === "Completada")[0].citas,
            );

          var total = atend + complet;
          setAtendidos(total);
        }
      })
      .then(async (nxt) => {
        await getPacientesTotal(idNegocio).then((res) => {
          if (res.length > 0) {
            setTotPacientes(
              res.filter((c) => c.campo === "pacientes")[0].conteo,
            );
            setTotExpedientes(
              res.filter((c) => c.campo === "expedientes")[0].conteo,
            );
          }
        });
      });
  };

  const loadPacientesRecientes = async () => {
    await getPacientesRecientes(idNegocio)
      .then((res) => {
        setPacientes(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const fetchCitas = async (opcion) => {
    const date = fechaHoy.fechaFmtUsa;
    await getCitas(idNegocio, date, opcion)
      .then((nxt) => {
        setCitas(nxt.lstCitas);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Inicio de sesión",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const handleDisabledDate = (date) => {
    return date.getTime() < moment().startOf("day").valueOf();
  };

  const fetchHorarios = async (fecha) => {
    await getHorarios(idNegocio, fecha).then((nxt) => {
      setFechaHorario(fecha);
      setDataHorarios(nxt);
    });
  };

  const handleHorario = (e) => {
    if (e === null) {
      setNuevaFecha("");
      setHorario("");
      setDisableBtn(true);
      setMessage("");
    } else {
      setNuevaFecha(e);
      setHorario(e);
      setDisableBtn(false);
      const _hor = e.substring(0, 5);
      const _fec = moment(fechaHorario).format("DD/MM/YYYY");
      setMessage(
        `Buen día, le escribimos del ${negocio.NomConsultorio}. Confirmando su cambio de Fecha y hora de la cita para el: ${_fec} en el horario de las: ${_hor}`,
      );
    }
  };

  const getPacientePorNombre = async (nombre) => {
    const response = await getPacienteXNombre(idNegocio);
    setDataPaciente(response);
  };

  const handleNewCita = async (props) => {
    setListaPacientes([{ label: "+ NUEVO PACIENTE", value: "-1" }]);
    setSowListaPac(true);
    var fec = moment(fechaHoy).format("DD/MM/YYYY");
    setIdPaciente("");
    setDataEdit(`${fec}`);
    setHorario(props.hora);
    setHorNvaCita(props.hora);
    setTelefono("");
    setPaciente("");
    setMessage("");
    setHoraIni("");
    setNuevaCita(true);
    setTipoHorario(props.opcion);
    setFecha(moment(fechaHoy).format("YYYY-MM-DD"));
    setNuevaFecha(moment(fechaHoy).format("YYYY-MM-DD"));
    setNuevaCita(props.nuevaCita);

    getPacientePorNombre();
    setNuevoPac(false);
    setOpenHor(true);

    await getListaPacientes(idNegocio).then((res) => {
      setListaPacientes((prev) => [...prev, ...res]);
    });
  };

  const handleSendData = async () => {
    fetchCitas(opcionSelecc)
      .then((res) => {
        loadKPIS();
      })
      .catch((err) => {
        toast(err.name, err.message);
      });
  };

  const save = async () => {
    try {
      if (telefono.length < 10) {
        toast("Debes colocar un numero teléfóno.", "error");
        return;
      }

      if (!paciente && nuevoPac) {
        toast("El nombre no puede estar vacio", "error");
        return;
      }

      if (tipoHorario === "horarioLibre" && !horaIni) {
        toast("El horario no puede estar vacio", "error");
        return;
      }

      setIsLoading(true);

      const _idPac = idPaciente;
      const ID = _idPac.split("-")[0];

      const dataCita = {
        id: idNegocio,
        idPaciente: ID,
        espacio: espacio,
        fechaAnterior:
          fecha !== "" ? moment(fecha).format("DD-MM-YYYY") : fecha,
        fecha: fecha !== "" ? moment(fecha).format("DD-MM-YYYY") : fecha,
        hora: tipoHorario === "horarioLibre" ? horaIni : horario,
        nombre: paciente,
        telefono: telefono,
        correo: "",
        domicilio: "",
        edoMun: "",
        descripCita: "",
        nuevaCita: nuevaCita,
        tipoHorario: tipoHorario,
      };

      // console.log(dataCita);
      const res = await saveUpdateCita(dataCita);
      if (res.data === -1) {
        toast("El horario no se encuentra disponible.", "warning");
        setIsLoading(false);
        return;
      }
      if (res.data === -2) {
        toast(
          "La cita no puede ser re-programada ya se ha realizado.",
          "warning",
        );
        setIsLoading(false);
        return;
      }

      if (res.data === -3) {
        toast(
          "La cita no puede ser programada el horario esta ocupado.",
          "warning",
        );
        setIsLoading(false);
        return;
      }

      toast("Se actualizo la cita de forma correcta", "success");
      setDisableBtn(true);
      setDisabledBtnMsj(false);

      fetchCitas(opcionSelecc).then((res) => {
        setIsLoading(false);
        loadKPIS();
      });
      setOpenHor(false);
    } catch (error) {
      setIsLoading(false);
      toast(error.message, "error");
    }
  };

  const handleConfirmModal = (props) => {
    setIdPaciente(props.idPac);
    setFechaCita(fechaHoy.fechaFmtMx);
    setEspacio(props.espacio);
    setTelefono(props.telefono);
    setHorario(props.hora);
    setOpenConfirm(true);
    const _message = JSON.parse(localStorage.getItem("auth")).confApp
      .msjConfirm;
    const messageFec = _message.replace(/({fecha})/, fechaHoy.fechaCorta);
    const finalMessage = messageFec.replace(/({hora})/, props.hora);

    setMessageConfirm(finalMessage);

    setDataConfirm(
      `${props.nombre} / (${props.espacio}) ${fechaHoy.fechaFmtMx} ${props.hora}`,
    );
  };

  const handleCancel = (props) => {
    if (props.estatus === "Cancelada") {
      setBtnCancel(true);
    } else {
      setBtnCancel(false);
    }

    setFechaCita(`${fechaCita} ${props.hora}`);
    setDataCancel(
      `${props.nombre} / (${props.espacio}) ${fechaCita} ${props.hora}`,
    );
    setEspacio(props.espacio);
    setOpen(true);
  };

  const handleEditModal = (props) => {
    setSowListaPac(true);
    setIdPaciente(props.idPac);
    setDisabledBtnMsj(true);
    setMessage("");
    setTipoHorario(props.opcion);
    setFecha(props.fecha);
    setFechaCita(`${props.fecha} ${props.hora}`);
    setDataEdit(
      `${props.nombre} / (${props.espacio}) ${fechaCita} ${props.hora}`,
    );
    setEspacio(props.espacio);
    setTelefono(props.telefono);
    setPaciente(props.nombre);
    setNuevaCita(false);
    setNuevoPac(false);
    setOpenHor(true);
  };

  const cancelarCita = async () => {
    const datos = {
      id: idNegocio,
      espacio: espacio,
      fecha: fechaCita,
      idUser: idUser,
      motivo: motivoCancel,
    };

    if (!motivoCancel) {
      toast("Debes escribir un motivo antes de guardar", "warning");
      return;
    }

    const res = await saveCancelCita(datos);

    if (res.data === -1) {
      toast(
        "No se ha cancelado la cita, porque ya se registro la consulta.",
        "warning",
      );
      return;
    }
    if (res.data === 0) {
      toast("No se ha cancelado la cita, intente nuevamente.", "warning");
      return;
    } else {
      toast("La cita se ha cancelado de forma correcta.", "success");
      setOpen(false);

      fetchCitas(opcionSelecc).then((res) => {
        loadKPIS();
      });
    }
  };

  const iniciaConsulta = (props) => {
    if(perfil === 'Asistente'){
      errorNotificaction("Acceso", "El usuario no puede iniciar la consulta.");
      return;
    }
    const getCita = {
      idConsulta: props.idConsulta,
      espacio: props.espacio,
      idPac: props.idPac,
      nombre: props.nombre,
      fecha: fechaHoy.fechaFmtUsa,
      hora: props.hora,
      precio: props.precio,
      telefono: props.telefono,
    };

    localStorage.setItem("getCita", JSON.stringify(getCita));
    window.location = `/#/Home/Dashboard/Consulta/${props.espacio}`;
  };

  const goToPage = (page) => {
    window.location = `/#/Home/${page}`;
  };

  const getStatusBadge = (estado) => {
    switch (estado) {
      case "Disponible":
        return (
          <span className="px-2.5 py-1 text-xs font-semibold rounded-full bg-amber-100 text-amber-800 flex items-center gap-1 w-fit">
            <Clock className="w-3 h-3" /> Disponible
          </span>
        );
      case "Confirmada":
        return (
          <span className="px-2.5 py-1 text-xs font-semibold rounded-full bg-cyan-100 text-black-800 flex items-center gap-1 w-fit">
            <CheckCircle2 className="w-3 h-3" /> Confirmada
          </span>
        );
      case "Realizada":
        return (
          <span className="px-2.5 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800 flex items-center gap-1 w-fit">
            <UserCheck className="w-3 h-3" /> Realizada
          </span>
        );
      case "Completada":
        return (
          <span className="px-2.5 py-1 text-xs font-semibold rounded-full bg-emerald-100 text-emerald-800 flex items-center gap-1 w-fit">
            <UserCheck className="w-3 h-3" /> Completada
          </span>
        );
      case "Cancelada":
        return (
          <span className="px-2.5 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800 flex items-center gap-1 w-fit">
            <AlertCircle className="w-3 h-3" /> Cancelada
          </span>
        );
      case "Pendiente":
      default:
        return (
          <span className="px-2.5 py-1 text-xs font-semibold rounded-full bg-slate-100 text-slate-700 flex items-center gap-1 w-fit">
            <AlertCircle className="w-3 h-3" /> Pendiente
          </span>
        );
    }
  };

  const handleOpenCobro = async (props) => {
    await getDatosConsulta(idNegocio, props.idPaciente, props.hora)
      .then((res) => {
        setIdConsulta(res.idConsulta);
        setPaciente(props.paciente);
        setServicio(res.servicio);
        setPrecio(res.precio);
        setTimeout(() => {
          modalCobro.current.open();
        }, [500]);
      })
      .catch((err) => {
        toast(err.message, err.name);
      });
  };

  const handleTipoOpc = (e) => {
    if (e !== null) {
      fetchCitas(e);
      setOpcSelecc(e);
    } else {
      setOpcSelecc("");
    }
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      fetchCitas(defaultVal).then((nxt) => {
        loadKPIS().then((res) => {
          loadPacientesRecientes();
        });
      });
    }
  }, []); // Empty dependency array ensures this effect runs only once on mount

  return (
    <div>
      {contextHolder}
      <LayoutMain titleItem={"Dashboard"}>
        <div className="space-y-6">
          {/* Welcome banner */}
          <div className="bg-gradient-to-r from-slate-900 via-blue-950 to-slate-900 rounded-2xl p-6 sm:p-8 text-white shadow-xl relative overflow-hidden">
            <div className="absolute -right-10 -bottom-10 w-60 h-60 bg-cyan-500/10 rounded-full blur-3xl pointer-events-none"></div>
            <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-4">
              <div>
                <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">
                  Bienvenid@ de nuevo, {nombreMedico}
                </h2>
                <p className="text-slate-300 text-sm mt-1 max-w-xl">
                  Tienes{" "}
                  <strong className="text-cyan-400 font-semibold">
                    {citasHoy} citas confirmadas
                  </strong>{" "}
                  para el día de hoy. {citasProg} en estado de espera.
                </p>
              </div>
              <button
                onClick={() =>
                  handleNewCita({
                    idPac: 0,
                    nombre: "",
                    fecha: fechaCita,
                    hora: "",
                    telefono: "",
                    nuevaCita: true,
                    opcion: "horarioLibre",
                  })
                }
                className="self-start md:self-auto bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-bold px-5 py-2.5 rounded-xl text-sm transition-all shadow-lg shadow-cyan-500/25 flex items-center gap-2"
              >
                <Plus className="w-4 h-4" /> Agendar Consulta
              </button>
            </div>
          </div>

          {/* KPI Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            <div className="bg-white p-5 rounded-2xl border border-slate-200/80 shadow-sm flex items-center justify-between">
              <div>
                <p className="text-xs font-medium text-slate-500 uppercase tracking-wider">
                  Citas para Hoy
                </p>
                <h3 className="text-2xl font-bold text-slate-800 mt-1">
                  {parseFloat(citasHoy) + parseFloat(citasProg)}
                </h3>
                <span className="text-xs text-emerald-600 font-medium flex items-center gap-1 mt-1">
                  <Activity className="w-3 h-3" /> Agenda del día
                </span>
              </div>
              <div className="w-12 h-12 bg-blue-50 text-blue-600 rounded-2xl flex items-center justify-center">
                <Calendar className="w-6 h-6" />
              </div>
            </div>

            <div className="bg-white p-5 rounded-2xl border border-slate-200/80 shadow-sm flex items-center justify-between">
              <div>
                <p className="text-xs font-medium text-slate-500 uppercase tracking-wider">
                  Pacientes Totales
                </p>
                <h3 className="text-2xl font-bold text-slate-800 mt-1">
                  {totPacientes}
                </h3>
                <span className="text-xs text-cyan-600 font-medium flex items-center gap-1 mt-1">
                  {/* +2 esta semana */}
                  Actuales
                </span>
              </div>
              <div className="w-12 h-12 bg-cyan-50 text-cyan-600 rounded-2xl flex items-center justify-center">
                <Users className="w-6 h-6" />
              </div>
            </div>

            <div className="bg-white p-5 rounded-2xl border border-slate-200/80 shadow-sm flex items-center justify-between">
              <div>
                <p className="text-xs font-medium text-slate-500 uppercase tracking-wider">
                  Expedientes Activos
                </p>
                <h3 className="text-2xl font-bold text-slate-800 mt-1">
                  {totExpedientes}
                </h3>
                <span className="text-xs text-emerald-600 font-medium flex items-center gap-1 mt-1">
                  100% digitalizados
                </span>
              </div>
              <div className="w-12 h-12 bg-emerald-50 text-emerald-600 rounded-2xl flex items-center justify-center">
                <FileText className="w-6 h-6" />
              </div>
            </div>

            <div className="bg-white p-5 rounded-2xl border border-slate-200/80 shadow-sm flex items-center justify-between">
              <div>
                <p className="text-xs font-medium text-slate-500 uppercase tracking-wider">
                  Pacientes Atendidos
                </p>
                <h3 className="text-2xl font-bold text-slate-800 mt-1">
                  {atendidos}
                </h3>
                <span className="text-xs text-indigo-600 font-medium flex items-center gap-1 mt-1">
                  Todos los turnos
                </span>
              </div>
              <div className="w-12 h-12 bg-indigo-50 text-indigo-600 rounded-2xl flex items-center justify-center">
                <UserCheck className="w-6 h-6" />
              </div>
            </div>
          </div>

          {/* Grid Section: Today's Appointments & Quick Patient Directory */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Today's Appointments */}
            <div className="lg:col-span-2 bg-white rounded-2xl border border-slate-200/80 shadow-sm p-6">
              <div className="flex items-center justify-between mb-5">
                <div>
                  <h3 className="font-bold text-slate-800 text-base">
                    Próximas Citas de Hoy
                  </h3>
                  <p className="text-sm text-slate-500">
                    <SelectPicker
                      searchable={false}
                      data={listaOpc}
                      size="sm"
                      defaultValue={`${defaultVal}`}
                      style={{ width: "100%" }}
                      block
                      placeholder="Filtrar por"
                      onChange={(e) => handleTipoOpc(e)}
                    ></SelectPicker>
                  </p>
                </div>
                <button
                  onClick={() => goToPage("AgendaSemana")}
                  className="text-xs font-semibold text-cyan-600 hover:text-cyan-700 flex items-center gap-1"
                >
                  AGENDA SEMANAL <ChevronRight className="w-4 h-4" />
                </button>
              </div>

              <div className="space-y-3">
                {citas === undefined ? (
                  <div className="p-4 rounded-xl border border-slate-100 bg-slate-50/50 transition-all flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                      <p className="text-sm text-slate-500">
                        NO SE ENCONTRARÓN REGISTROS
                      </p>
                    </div>
                  </div>
                ) : (
                  citas.map((cita, index) => (
                    <div
                      key={index}
                      className="p-4 rounded-xl border border-slate-100 hover:border-slate-200 bg-slate-50/50 transition-all flex flex-col sm:flex-row sm:items-center justify-between gap-4"
                    >
                      <div className="flex items-center gap-3">
                        <img
                          src={
                            cita.estatus !== "Disponible"
                              ? cita.estatus === "Agendada"
                                ? "/Images/AvatarPacientePendiente.jpg"
                                : "/Images/AvatarPaciente.jpg"
                              : "/Images/AvatarReloj.jpg"
                          }
                          alt={cita.nombre}
                          className="w-11 h-11 rounded-full object-cover"
                        />
                        <div>
                          <h4 className="font-semibold text-slate-800 text-sm">
                            {cita.paciente}
                          </h4>
                          <div className="flex items-center gap-2 text-sm text-slate-500 mt-0.5">
                            <span className="font-bold flex items-center gap-1">
                              <Clock className="w-3.5 h-3.5 text-slate-400" /> (
                              {cita.espacio}) {cita.hora}
                            </span>
                            <span>•</span>
                            <span>
                              {cita.estatus === "Disponible" ? (
                                <Button
                                  color="green"
                                  size="sm"
                                  appearance="ghost"
                                  onClick={() =>
                                    handleNewCita({
                                      idPac: 0,
                                      nombre: "",
                                      fecha: fechaCita,
                                      hora: cita.hora,
                                      telefono: "",
                                      nuevaCita: true,
                                      opcion: "horarioDisp",
                                    })
                                  }
                                >
                                  {cita.nombre + " (" + cita.espacio + ")"}
                                </Button>
                              ) : cita.estatus === "Confirmada" ? (
                                <GlassButton
                                  onClick={() =>
                                    iniciaConsulta({
                                      idConsulta: cita.idConsulta,
                                      espacio: cita.espacio,
                                      idPac: cita.idPac,
                                      fecha: cita.fecha,
                                      hora: cita.hora,
                                      telefono: cita.telefono,
                                      precio: cita.precio,
                                      nombre: cita.nombre,
                                    })
                                  }
                                >
                                  {cita.nombre}
                                </GlassButton>
                              ) : (
                                cita.nombre
                              )}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="flex items-center gap-3 justify-between sm:justify-end">
                        {getStatusBadge(cita.estatus)}

                        {cita.estatus === "Completada" ? (
                          ""
                        ) : cita.estatus === "Realizada" ? (
                          <Button
                            color="green"
                            appearance="ghost"
                            size="xs"
                            onClick={() =>
                              handleOpenCobro({
                                idPaciente: cita.idPac,
                                hora: cita.hora,
                                paciente: cita.nombre,
                              })
                            }
                          >
                            <FaCashRegister></FaCashRegister>
                            &nbsp; Cobrar
                          </Button>
                        ) : cita.estatus !== "Disponible" ? (
                          <>
                            <Button
                              appearance="subtle"
                              disabled={
                                cita.estatus === "Realizada" ? true : false
                              }
                              title="Cancelar cita"
                              onClick={() =>
                                handleCancel({
                                  nombre: cita.nombre,
                                  fecha: fechaCita,
                                  espacio: cita.espacio,
                                  hora: cita.hora,
                                  telefono: cita.telefono,
                                  estatus: cita.estatus,
                                })
                              }
                            >
                              <FaTrash style={{ color: "red" }}></FaTrash>
                            </Button>
                            <Button
                              onClick={() =>
                                handleEditModal({
                                  idPac: cita.idPac,
                                  espacio: cita.espacio,
                                  nombre: cita.nombre,
                                  fecha: fechaCita,
                                  hora: cita.hora,
                                  telefono: cita.telefono,
                                  nuevaCita: false,
                                  opcion: "horarioLibre",
                                })
                              }
                              disabled={
                                cita.estatus === "Confirmada" ||
                                cita.estatus === "Realizada"
                                  ? true
                                  : false
                              }
                              appearance="subtle"
                              title="Editar horario"
                            >
                              <ClockIcon
                                size="15px"
                                style={{ color: "blue" }}
                              ></ClockIcon>
                            </Button>
                            <Button
                              onClick={() =>
                                handleConfirmModal({
                                  idPac: cita.idPac,
                                  espacio: cita.espacio,
                                  nombre: cita.nombre,
                                  fecha: cita.fecha,
                                  hora: cita.hora,
                                  telefono: cita.telefono,
                                  nuevaCita: false,
                                  opcion: "horarioLibre",
                                  estatus: cita.estatus,
                                })
                              }
                              disabled={
                                cita.estatus === "Confirmada" ||
                                cita.estatus === "Realizada"
                                  ? true
                                  : false
                              }
                              color="green"
                              appearance="subtle"
                              title="Confirmar cita"
                            >
                              <CheckIcon
                                size="20px"
                                style={{ color: "green" }}
                              ></CheckIcon>
                            </Button>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>

            {/* Patient Mini-List */}
            <div className="bg-white rounded-2xl border border-slate-200/80 shadow-sm p-6 flex flex-col justify-between">
              <div>
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-bold text-slate-800 text-base">
                    Pacientes Recientes
                  </h3>
                  <button
                    onClick={() => setIsPacienteModalOpen(true)}
                    className="p-1 text-cyan-600 hover:bg-cyan-50 rounded-lg"
                  >
                    <Plus className="w-5 h-5" />
                  </button>
                </div>

                <div className="divide-y divide-slate-100">
                  {pacientes.slice(0, 4).map((pac) => (
                    <div
                      key={pac.id}
                      onClick={() => {
                        setSelectedPaciente(pac);
                      }}
                      className="py-3 flex items-center justify-between hover:bg-slate-50 rounded-lg px-2 transition-colors cursor-pointer"
                    >
                      <div>
                        <p className="font-medium text-slate-800 text-sm">
                          {pac.nombre}
                        </p>
                        <p className="text-xs text-slate-500">
                          {pac.genero}, {pac.edad} años
                        </p>
                      </div>
                      <span className="text-xs font-mono font-semibold px-2 py-1 bg-slate-100 text-slate-600 rounded-md">
                        {pac.ciudad}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              <button
                onClick={() => goToPage("Pacientes")}
                className="w-full mt-4 py-2.5 bg-slate-100 hover:bg-slate-200/70 text-slate-700 font-semibold rounded-xl text-xs transition-colors"
              >
                Ver Directorio Completo
              </button>
            </div>
          </div>
        </div>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL DE EDICION PARA HORARIO Y NUEVA CITA O RE-PROG <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          size="md"
          open={openHor}
          onClose={handleCloseHorario}
          backdrop="static"
          overflow="false"
        >
          <Modal.Header>
            <Modal.Title>Nueva Cita</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel bordered>
              <div className="row mb-1">
                <div className="col-lg-8 col-md-8 col-sm-8">
                  <b>Nombre</b>
                  <span style={{ color: "red", fontSize: "12px" }}>
                    &nbsp; * Obligatorio
                  </span>
                  {showListaPac ? (
                    <SelectPicker
                      key={`pickerPacientes`}
                      width={"100%"}
                      data={listaPacientes}
                      value={idPaciente}
                      onChange={(e) => hanldeNombrePaciente(e)}
                      style={{ borderRadius: "15px" }}
                      searchable
                      placeholder="Selecciona un paciente..."
                      block
                    />
                  ) : !nuevoPac ? (
                    <Input
                      readOnly
                      value={paciente}
                      style={{ borderRadius: "15px" }}
                    />
                  ) : (
                    <Input
                      value={paciente}
                      onChange={(e) => handleNuevoNombre(e)}
                      style={{ borderRadius: "10px" }}
                    />
                  )}

                  {/* <AutoComplete
                    data={nuevoPac ? [] : dataPaciente}
                    width={"100%"}
                    onChange={(e) => hanldeNombrePaciente(e)}
                  /> */}
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4">
                  <b>Teléfono</b>
                  <span style={{ color: "red", fontSize: "12px" }}>
                    &nbsp; * Obligatorio
                  </span>
                  <NumberInput
                    controls={false}
                    value={telefono}
                    onChange={(e) => handleChangeTelefono(e)}
                    style={{ borderRadius: "10px" }}
                    maxLength={10}
                    min={0}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <b>Fecha</b>
                  {tipoHorario === "horarioDisp" ? (
                    <Input
                      readOnly
                      value={moment(fechaHoy).format("DD/MM/YYYY")}
                      style={{ textAlign: "center", borderRadius: "10px" }}
                    />
                  ) : tipoHorario === "Reprog" ||
                    tipoHorario === "horarioLibre" ? (
                    <CustomProvider locale={es_ES}>
                      <DatePicker
                        block
                        shouldDisableDate={handleDisabledDate}
                        onChange={(e) => handleChangeFec(e)}
                        style={{ borderRadius: "10px" }}
                      />
                    </CustomProvider>
                  ) : (
                    <Input
                      readOnly
                      value={nuevaFecha}
                      style={{ textAlign: "center", borderRadius: "10px" }}
                    />
                  )}
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <b>Horario</b>
                  {tipoHorario === "horarioDisp" ? (
                    <Input
                      readOnly
                      value={horNvaCita}
                      defaultValue={horNvaCita}
                      style={{ textAlign: "center", borderRadius: "10px" }}
                    />
                  ) : tipoHorario === "Reprog" ? (
                    <SelectPicker
                      style={{ width: "auto", borderRadius: "10px" }}
                      block
                      searchable={false}
                      data={dataHorarios}
                      disabled={disableHors}
                      onChange={(e) => handleHorario(e)}
                      placeholder="Selecciona un horario"
                    />
                  ) : (
                    <Input
                      placeholder="00:00"
                      maxLength={5}
                      value={horaIni}
                      onChange={(e) => maskTime(e)}
                      style={{ textAlign: "center", borderRadius: "10px" }}
                    />
                  )}
                </div>
              </div>
              <div className="row">
                {!nuevaCita ? (
                  <div className="col">
                    <b>Mensaje</b>
                    <Input
                      as="textarea"
                      rows={3}
                      value={message}
                      onChange={(e) => setMessage(e)}
                      style={{ borderRadius: "10px" }}
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              onClick={handleCloseHorario}
              className="w-50 px-4 py-2 bg-slate-100 text-sm font-semibold text-slate-600 hover:bg-slate-300 rounded-xl transition-colors"
            >
              Cancelar
            </button>

            <button
              type="button"
              onClick={save}
              disabled={isLoading}
              className="w-50 px-4 py-2 text-xs font-semibold flex items-center justify-center gap-2 bg-cyan-600 hover:bg-cyan-700 text-white rounded-xl transition-colors shadow-md shadow-cyan-600/20"
            >
              {isLoading ? (
                <>
                  <RefreshCw className="w-4 h-4 animate-spin" /> Guardando...
                </>
              ) : (
                <>Guardar cita</>
              )}
            </button>
          </Modal.Footer>
        </Modal>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL PARA CANCELACIONES <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          open={open}
          onClose={handleClose}
          backdrop="static"
          overflow="false"
        >
          <Modal.Header>
            <Modal.Title style={{ fontSize: "16px" }}>{dataCancel}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel bordered>
              <div className="row">
                <div className="col">
                  <b>Motivo</b>
                  <Input
                    as="textarea"
                    rows={4}
                    placeholder="Escriba el motivo de la cancelación de la cita."
                    onChange={(e) => setMotivoCancel(e)}
                    disabled={btnCancel}
                  />
                </div>
              </div>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              onClick={handleClose}
              className="w-50 px-4 py-2 bg-slate-100 text-sm font-semibold text-slate-600 hover:bg-slate-300 rounded-xl transition-colors"
            >
              Cancelar
            </button>

            <button
              type="button"
              onClick={cancelarCita}
              className="w-50 px-4 py-2 text-xs font-semibold flex items-center justify-center gap-2 bg-cyan-600 hover:bg-cyan-700 text-white rounded-xl transition-colors shadow-md shadow-cyan-600/20"
            >
              Guardar
            </button>
          </Modal.Footer>
        </Modal>

        {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL PARA CONFIRMACIÓN <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
        <Modal
          open={openConfirm}
          onClose={handleCloseConfirm}
          backdrop="static"
          overflow="false"
        >
          <Modal.Header>
            <Modal.Title style={{ fontSize: "16px" }}>
              {dataConfirm}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Panel bordered>
              <div className="row">
                <div className="col">
                  <b>Mensaje de confirmación</b>
                  <Input
                    as="textarea"
                    rows={16}
                    value={messageConfirm}
                    onChange={(e) => setMessageConfirm(e)}
                  />
                </div>
              </div>
            </Panel>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={saveConfirm} appearance="ghost">
              Guardar
            </Button>
            <Button appearance="ghost" onClick={() => sendMessage()} size="md">
              <Image
                src="/Images/whatsapp.png"
                style={{ height: "30px" }}
              ></Image>
              &nbsp; Enviar mensaje
            </Button>
            <Button onClick={handleCloseConfirm} appearance="ghost">
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>

        <ModalCobro
          ref={modalCobro}
          idNegocio={idNegocio}
          idConsulta={idConsulta}
          paciente={paciente}
          servicio={servicio}
          precioConsulta={precio}
          onSendData={handleSendData}
        />

        <Drawer open={openAgenda} onClose={() => setOpenAgenda(false)}>
          <Drawer.Header>
            <Drawer.Title>Agenda</Drawer.Title>
          </Drawer.Header>
          <Drawer.Body>
            <Agenda />
          </Drawer.Body>
        </Drawer>
      </LayoutMain>
    </div>
  );
};
